import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = ({ onOpenContactForm }) => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-wine-950 border-t border-wine-800/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <span className="text-xl font-bold text-white tracking-tight block mb-4">Trademark Text Logo</span>
            <p className="text-wine-400 text-sm leading-relaxed">Your trusted partner for trademark registration, copyright protection, LLC formation, and Amazon Brand Registry services.</p>
          </div>

          <div>
            <h4 className="font-semibold text-wine-200 text-sm uppercase tracking-wider mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'Pricing', 'Testimonials', 'FAQ'].map((label) => (
                <li key={label}><button onClick={() => scrollToSection(label.toLowerCase())} className="text-sm text-wine-400 hover:text-gold-400 transition-colors">{label}</button></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-wine-200 text-sm uppercase tracking-wider mb-5">Our Services</h4>
            <ul className="space-y-3">
              {[
                { label: 'Trademark Registration', path: '/services/trademark-registration' },
                { label: 'Copyright Registration', path: '/services/copyright-registration' },
                { label: 'Company Formation', path: '/services/company-formation' },
                { label: 'Trademark Search', path: '/services/trademark-search' },
                { label: 'Amazon Brand Registry', path: '/services/amazon-brand-registry' },
              ].map((item) => (
                <li key={item.path}><Link to={item.path} className="text-sm text-wine-400 hover:text-gold-400 transition-colors">{item.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-wine-200 text-sm uppercase tracking-wider mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-gold-400 mt-0.5 flex-shrink-0" />
                <div><div className="text-xs text-wine-500">Phone</div><a href="tel:+18005551234" className="text-sm text-white hover:text-gold-400 transition-colors">(800) 555-1234</a></div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-gold-400 mt-0.5 flex-shrink-0" />
                <div><div className="text-xs text-wine-500">Email</div><a href="mailto:info@trademarktextlogo.com" className="text-sm text-white hover:text-gold-400 transition-colors">info@trademarktextlogo.com</a></div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-gold-400 mt-0.5 flex-shrink-0" />
                <div><div className="text-xs text-wine-500">Address</div><div className="text-sm text-white">18952 MacArthur Blvd Suite 100<br/>Irvine, CA 92612</div></div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-wine-800/40 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-wine-500 text-xs">&copy; {currentYear} Trademark Text Logo. All rights reserved.</p>
            <div className="flex gap-6 text-xs">
              <Link to="/privacy-policy" className="text-wine-500 hover:text-gold-400 transition-colors">Privacy Policy</Link>
              <Link to="/terms-conditions" className="text-wine-500 hover:text-gold-400 transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
